import { render } from "./signUpPage.vue?vue&type=template&id=2c82bcb0&scoped=true"
import script from "./signUpPage.vue?vue&type=script&lang=js"
export * from "./signUpPage.vue?vue&type=script&lang=js"

import "./signUpPage.vue?vue&type=style&index=0&id=2c82bcb0&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c82bcb0"]])

export default __exports__